export function GetPaymentProcessors() {
  return [
    {
      key: 0,
      description: "Stripe"
    },
    {
      key: 1,
      description: "Midtrans"
    },
    {
      key: 2,
      description: "Doku"
    }
  ];
}

export function GetPaymentProcessorDescription(value) {
  let paymentProcessor = GetPaymentProcessors().find(
    item => item.key === value
  );
  if (paymentProcessor !== undefined) return paymentProcessor.description;
  return value;
}
